var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgObPencilGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#OBPencilGray_svg__clip0_7773_1944)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.707 2.293a1 1 0 00-1.414 0l-2.996 2.995-.004.005-.004.004-8.996 8.996a1 1 0 00-.242.39l-2 6a1 1 0 001.265 1.266l6-2a1 1 0 00.391-.242l12-12a1 1 0 000-1.414l-4-4zM18 8.586L19.586 7 17 4.414 15.414 6 18 8.586zm-4-1.172L16.586 10 8.46 18.126 4.58 19.419l1.293-3.879L14 7.414z",
    fill: "#333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "OBPencilGray_svg__clip0_7773_1944"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 2)",
    d: "M0 0h20v20H0z"
  })))));
}

export default SvgObPencilGray;